import styled from "styled-components";

export const SpinnerStyles = styled.div`
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  background-color: white;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;
